import { mainFrameRect } from './rects'

export function signatureTopY() {
  let frame = mainFrameRect()
  return frame.y + 250 + 360 + 1170 - 100
}